export const questions_list = [
     {
      id: 1,
      "type": "Present",
      "question": "In your reality today, people's interest and appreciation of work.",
      "negative": "People do not like work and avoid it as much as possible.",
      "positive": "People are interested in their work and need it to flourish. In good conditions, they enjoy it."
    },
    { id: 2,
      "type": "Future",
      "question": "In your representation of work tomorrow, people's interest and appreciation of work.",
      "negative": "People do not like work and avoid it as much as possible.",
      "positive": "People are interested in their work and need it to flourish. In good conditions, they enjoy it."
    },
    { id:3,
      "type": "Present",
      "question": "In your reality today, the measures taken to encourage people to make an effort.",
      "negative": "People must be compelled or 'incentivized' to make the right effort.",
      "positive": "People move towards a goal if they understand it."
    },
    { id:4,
      "type": "Future",
      "question": "In your representation of work tomorrow, the measures taken to encourage people to make an effort.",
      "negative": "People must be compelled or 'incentivized' to make the right effort.",
      "positive": "People will move towards a goal if they understand it."
    },
    { id:5,
      "type": "Present",
      "question": "In your reality today, people's preference for leadership and responsibility.",
      "negative": "People prefer to be led and not take responsibility.",
      "positive": "Under the right conditions, people will seek and accept responsibilities."
    },
    { id:6,
      "type": "Future",
      "question": "In your representation of work tomorrow, people's preference for leadership and responsibility.",
      "negative": "People prefer to be led and not take responsibility.",
      "positive": "Under the right conditions, people will seek and accept responsibilities."
    },
    { id:7,
      "type": "Present",
      "question": "In your reality today, the primary motivations driving people.",
      "negative": "People are primarily motivated by money and the fear of losing their job.",
      "positive": "Under good conditions, people are motivated by the desire to tap into their own potential."
    },
    { id:8,
      "type": "Future",
      "question": "In your representation of work tomorrow, the primary motivations driving people.",
      "negative": "People are primarily motivated by money and the fear of losing their job.",
      "positive": "Under good conditions, people are motivated by the desire to tap into their own potential."
    },
    { id:9,
      "type": "Present",
      "question": "In your reality today, people's creativity and ability to work around rules.",
      "negative": "Most people have little creativity, except when it comes to circumventing rules.",
      "positive": "Creativity and ingenuity are widespread and widely used."
    },
    { id:10,
      "type": "Future",
      "question": "In your representation of work tomorrow, people's creativity and ability to work around rules.",
      "negative": "Most people have little creativity, except when it comes to circumventing rules.",
      "positive": "Creativity and ingenuity are widespread and widely used."
    },
    { id:11,
      "type": "Present",
      "question": "In your reality today, the nature of your company.",
      "negative": "Your company is mechanical, driven.",
      "positive": "Your company is systemic, alive, and market-oriented."
    },
    { id:12,
      "type": "Future",
      "question": "In your representation of work tomorrow, the nature of your company.",
      "negative": "Your company is mechanical, driven.",
      "positive": "Your company is systemic, alive, and market-oriented."
    },
    { id:13,
      "type": "Present",
      "question": "In your reality today, the organizational structure of your company.",
      "negative": "Your company is organized into functional divisions, focusing on individualization.",
      "positive": "Your company operates in functional integration, working as a team."
    },
    { id:14,
      "type": "Future",
      "question": "In your representation of work tomorrow, the organizational structure of your company.",
      "negative": "Your company is organized into functional divisions, focusing on individualization.",
      "positive": "Your company operates in functional integration, working as a team."
    },
    { id:15,
      "type": "Present",
      "question": "In your reality today, the management style of your company.",
      "negative": "Your company has a top-down, vertical management style.",
      "positive": "Your company is an outward-facing, socially dense organization."
    },
    { id:16,
      "type": "Future",
      "question": "In your representation of work tomorrow, the management style of your company.",
      "negative": "Your company has a top-down, vertical management style.",
      "positive": "Your company is an outward-facing, socially dense organization."
    },
    { id:17,
      "type": "Present",
      "question": "In your reality today, how your company operates internally.",
      "negative": "Your company operates in parallel, in silos.",
      "positive": "In your company, people work with and for each other."
    },
    { id:18,
      "type": "Future",
      "question": "In your representation of work tomorrow, how your company operates internally.",
      "negative": "Your company operates in parallel, in silos.",
      "positive": "In your company, people work with and for each other."
    },
    { id:19,
      "type": "Present",
      "question": "In your reality today, the approach and stability of your company.",
      "negative": "Your company is centralized, efficiency-oriented, and seeks stability.",
      "positive": "Your company is unifying, decentralizing, and adapted to complexity."
    },
    { id:20,
      "type": "Future",
      "question": "In your representation of work tomorrow, the approach and stability of your company.",
      "negative": "Your company is centralized, efficiency-oriented, and seeks stability.",
      "positive": "Your company is unifying, decentralizing, and adapted to complexity."
    },
    { id:21,
      "type": "Present",
      "question": "In your reality today, the independence and connection of your company's teams.",
      "negative": "Your company has teams dependent on their management.",
      "positive": "Your company has teams connected to its purpose."
    },
    { id:22,
      "type": "Future",
      "question": "In your representation of work tomorrow, the independence and connection of your company's teams.",
      "negative": "Your company has teams dependent on their management.",
      "positive": "Your company has teams connected to its purpose."
    },
    { id:23,
      "type": "Present",
      "question": "In your reality today, how work is assigned within your company.",
      "negative": "Your company divides work.",
      "positive": "Your company integrates employees into units."
    },
    { id:24,
      "type": "Future",
      "question": "In your representation of work tomorrow, how work is assigned within your company.",
      "negative": "Your company divides work.",
      "positive": "Your company integrates employees into units."
    },
    { id:25,
      "type": "Present",
      "question": "In your reality today, the decision-making style of your company's management.",
      "negative": "Your company employs directive management; the manager decides alone.",
      "positive": "Your company employs autonomous management; everyone makes decisions within their area of responsibility."
    },
    { id:26,
      "type": "Future",
      "question": "In your representation of work tomorrow, the decision-making style of your company's management.",
      "negative": "Your company employs directive management; the manager decides alone.",
      "positive": "Your company employs autonomous management."
    },
    { id:27,
      "type": "Present",
      "question": "In your reality today, how your company motivates its employees.",
      "negative": "Your company motivates employees with incentives.",
      "positive": "Your company motivates employees through participation."
    },
    { id:28,
      "type": "Future",
      "question": "In your representation of work tomorrow, how your company motivates its employees.",
      "negative": "Your company motivates employees with incentives.",
      "positive": "Your company motivates employees through participation."
    },
    { id:29,
      "type": "Present",
      "question": "In your reality today, the role delineation in your company.",
      "negative": "Your company uses job descriptions.",
      "positive": "Your company features dynamic roles and a sense of purpose."
    },
    { id:30,
      "type": "Future",
      "question": "In your representation of work tomorrow, the role delineation in your company.",
      "negative": "Your company uses job descriptions.",
      "positive": "Your company features dynamic roles and a sense of purpose."
    },
    { id:31,
      "type": "Present",
      "question": "In your reality today, the financial planning approach of your company.",
      "negative": "Your company plans for static financial allocations.",
      "positive": "Your company plans for dynamic financial allocations for value creation."
    },
    { id:32,
      "type": "Future",
      "question": "In your representation of work tomorrow, the financial planning approach of your company.",
      "negative": "Your company plans for static financial allocations.",
      "positive": "Your company plans for dynamic financial allocations for value creation."
    },
    { id:33,
      "type": "Present",
      "question": "In your reality today, how your company manages its finances.",
      "negative": "Your company budgets.",
      "positive": "Your company practices beyond budgeting - finance management that emphasizes flexibility and adaptability to changes."
    },
    { id:34,
      "type": "Future",
      "question": "In your representation of work tomorrow, how your company manages its finances.",
      "negative": "Your company budgets.",
      "positive": "Your company practices beyond budgeting - finance management that emphasizes flexibility and adaptability to changes."
    },
    { id:35,
      "type": "Present",
      "question": "In your reality today, the orientation of projects in your company.",
      "negative": "Projects in your company are oriented around the fiscal year.",
      "positive": "Project evolution in your company is paced by iteration."
    },
    { id:36,
      "type": "Future",
      "question": "In your representation of work tomorrow, the orientation of projects in your company.",
      "negative": "Projects in your company are oriented around the fiscal year.",
      "positive": "Project evolution in your company is paced by iteration."
    },
    { id:37,
      "type": "Present",
      "question": "In your reality today, the frequency and structure of meetings in your company.",
      "negative": "You have many meetings (few meeting practices/rituals).",
      "positive": "You have specific meeting practices and ensure everyone's voice is heard."
    },
    { id:38,
      "type": "Future",
      "question": "In your representation of work tomorrow, the frequency and structure of meetings in your company.",
      "negative": "You have many meetings (few meeting practices/rituals).",
      "positive": "You have specific meeting practices and ensure everyone's voice is heard."
    },
    { id:39,
      "type": "Present",
      "question": "In your reality today, the authority to initiate financial-impact actions in your company.",
      "negative": "Only the highest officials in your company can initiate financial-impact initiatives.",
      "positive": "Initiative-taking is distributed in your company; everyone perceives the right thing to do in their area of responsibility."
    },
    { id:40,
      "type": "Future",
      "question": "In your representation of work tomorrow, the authority to initiate financial-impact actions in your company.",
      "negative": "Only the highest officials in your company can initiate financial-impact initiatives.",
      "positive": "Initiative-taking is distributed in your company; everyone perceives the right thing to do in their area of responsibility."
    },
    { id:41,
      "type": "Present",
      "question": "In your reality today, the recruitment interview process in your company.",
      "negative": "Interviews are conducted by qualified HR, with the focus on fitting the job description.",
      "positive": "During recruitment interviews, the emphasis is on compatibility with future team members, the organization, and the company's purpose."
    },
    { id:42,
      "type": "Future",
      "question": "In your representation of work tomorrow, the recruitment interview process in your company.",
      "negative": "Interviews are conducted by qualified HR, with the focus on fitting the job description.",
      "positive": "During recruitment interviews, the emphasis is on compatibility with future team members, the organization, and the company's purpose."
    },
    { id:43,
      "type": "Present",
      "question": "In your reality today, the primary objective of your organization.",
      "negative": "The primary goal is your organization's self-preservation (regardless of its mission statement).",
      "positive": "You consider your organization a living entity with its own evolving purpose."
    },
    { id:44,
      "type": "Future",
      "question": "In your representation of work tomorrow, the primary objective of your organization.",
      "negative": "The primary goal is the organization's self-preservation (regardless of its mission statement).",
      "positive": "You consider it a living entity with its own evolving purpose."
    },
    { id:45,
      "type": "Present",
      "question": "In your reality today, the strategic orientation of your company.",
      "negative": "Your company has a strategic orientation defined by top executives.",
      "positive": "In your company, strategy organically emerges from the collective intelligence of employees and autonomous teams."
    },
    { id:46,
      "type": "Future",
      "question": "In your representation of work tomorrow, the strategic orientation of your company.",
      "negative": "Your company has a strategic orientation defined by top executives.",
      "positive": "In your company, strategy organically emerges from the collective intelligence of employees and autonomous teams."
    },
    { id:47,
      "type": "Present",
      "question": "In your reality today, success determinants for your company.",
      "negative": "Growth and market share are key success factors for your company.",
      "positive": "Growth and market share only matter insofar as they contribute to the realization of your company's purpose."
    },
    { id:48,
      "type": "Future",
      "question": "In your representation of work tomorrow, success determinants for your company.",
      "negative": "Growth and market share are key success factors for your company.",
      "positive": "Growth and market share only matter insofar as they contribute to the realization of your company's purpose."
    },
    { id:49,
      "type": "Present",
      "question": "In your reality today, the role of your organization in helping employees identify their personal vocation.",
      "negative": "It's not your organization's role to help employees identify their personal vocation.",
      "positive": "Recruitment, training, and evaluations are used to bridge individual aspirations and the organization's purpose."
    },
    { id:50,
      "type": "Future",
      "question": "In your representation of work tomorrow, the role of your organization in helping employees identify their personal vocation.",
      "negative": "It's not your organization's role to help employees identify their personal vocation.",
      "positive": "Recruitment, training, and evaluations are used to bridge individual aspirations and the organization's purpose."
    },
    { id:51,
      "type": "Present",
      "question": "In your reality today, the management principles your company employs.",
      "negative": "Your company applies the principles of 'forecast and control'.",
      "positive": "Your company applies the principles of 'sense and respond'."
    },
    { id:52,
      "type": "Future",
      "question": "In your representation of work tomorrow, the management principles your company employs.",
      "negative": "Your company applies the principles of 'forecast and control'.",
      "positive": "Your company applies the principles of 'sense and respond'."
    },
    { id:53,
      "type": "Present",
      "question": "In your reality today, adherence to plans within your company.",
      "negative": "In your company, the rule is to stick to the plan, deviations must be explained and bridged.",
      "positive": "Your company looks for feasible solutions and quick iterations instead of seeking 'perfect' answers and continuously sensing what's necessary."
    },
    { id:54,
      "type": "Future",
      "question": "In your representation of work tomorrow, adherence to plans within your company.",
      "negative": "In your company, the rule is to stick to the plan, deviations must be explained and bridged.",
      "positive": "Your company looks for feasible solutions and quick iterations instead of seeking 'perfect' answers and continuously sensing what's necessary."
    },
    { id:55,
      "type": "Present",
      "question": "In your reality today, project management and resource prioritization in your company.",
      "negative": "Your company tries to control complexity and prioritize resources with program and project managers, Gantt charts, plans, budgets, etc.",
      "positive": "Your company practices radically simplified project management - minimal (or non-existent) plans and budgets, organic prioritization, decentralized authority, and responsibility."
    },
    { id:56,
      "type": "Future",
      "question": "In your representation of work tomorrow, project management and resource prioritization in your company.",
      "negative": "Your company tries to control complexity and prioritize resources with program and project managers, Gantt charts, plans, budgets, etc.",
      "positive": "Your company practices radically simplified project management. Minimal (or non-existent) plans and budgets, organic prioritization. Decentralized authority and responsibility."
    },
    { id:57,
      "type": "Present",
      "question": "In your reality today, financial authorization within your company.",
      "negative": "There are authorization limits related to hierarchical level for purchases and investments.",
      "positive": "Financial authorization is decentralized based on competence, with a strong culture of 'customer-client' responsibility."
    },
    { id:58,
      "type": "Future",
      "question": "In your representation of work tomorrow, financial authorization within your company.",
      "negative": "There are authorization limits related to hierarchical level for purchases and investments.",
      "positive": "Financial authorization is decentralized based on competence, with a strong culture of 'customer-client' responsibility."
    },
    { id:59,
      "type": "Present",
      "question": "In your reality today, the way your company adapts to market changes.",
      "negative": "Adaptation requires significant time and resources.",
      "positive": "Your company is flexible and can quickly adapt to changes in the market environment."
    },
    { id:60,
      "type": "Future",
      "question": "In your representation of work tomorrow, the way your company adapts to market changes.",
      "negative": "Adaptation requires significant time and resources.",
      "positive": "Your company is flexible and can quickly adapt to changes in the market environment."
    },  
  
];
